module.exports = __webpack_public_path__ + "img/pic_picooc@2x.1c747061.png";